import React from "react";
import "./IntegrationsTab.scss";

const IntegrationsTab = ({ ...props }) => {
  return <div className="integrations-tab-content">IntegrationsTab</div>;
};

export default IntegrationsTab;
